export enum ReportMode {
    simu = 1,
    compare
}
